.floating-info {
  padding: 5px 10px;
  background: beige;
  border-radius: 5px;
  border: 1px solid black;
  display: inline-block;
  position: absolute;
  top: 0;
  margin-left: 10px;
  max-width: 18vw;
  word-wrap: break-word;
  opacity: 0;
  transition: all 500ms ease-in-out;
  z-index: 9;
}

.table span:empty {
  display: none;
}

.title-float:hover + .floating-info {
  opacity: 100;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/assets/css/home.css
// module id = 989
// module chunks = 0